import { useContext, useEffect, useState } from 'react';
import styles from './PopUpDetalhesPedido.module.css';
import { ClientesContext } from '../../../shared/contexts/ClientesContext';
import { numeroExibicaoPedido } from '../../../shared/utils/pedido';
import NotaFiscalPedido from './NotaFiscalPedido';

function PopUpDetalhesPedido({ pedido, onClose }) {
  const { clientes } = useContext(ClientesContext);
  const [itensPedido, setItensPedido] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchItensPedido = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch('http://localhost:3002/buscaitenspedido', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          const todosItens = await response.json();
          const itensDoPedido = todosItens.filter(
            item => item.id_pedido === pedido.id_pedido
          );
          setItensPedido(itensDoPedido);
        }
      } catch (error) {
        console.error('Erro ao buscar itens do pedido:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchItensPedido();
  }, [pedido.id_pedido]);

  const getNomeCliente = (id_cliente) => {
    const cliente = clientes.find(c => c.id_cliente === id_cliente);
    return cliente ? cliente.nome : `Cliente ${id_cliente}`;
  };

  const getEmailCliente = (id_cliente) => {
    const cliente = clientes.find(c => c.id_cliente === id_cliente);
    return cliente ? cliente.email_institucional : '-';
  };

  const getTelefoneCliente = (id_cliente) => {
    const cliente = clientes.find(c => c.id_cliente === id_cliente);
    return cliente ? cliente.telefone : '-';
  };

  const getStatusClass = (status) => {
    switch (status) {
      case 'pendente':
        return styles.statusPendente;
      case 'em andamento':
        return styles.statusAndamento;
      case 'pronto':
        return styles.statusPronto;
      case 'entregue':
        return styles.statusEntregue;
      default:
        return '';
    }
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div className={styles.headerTop}>
            <h2>Detalhes do Pedido #{numeroExibicaoPedido(pedido)}</h2>
            <button className={styles.closeButton} onClick={onClose}>
              ✕
            </button>
          </div>
          <span className={`${styles.statusBadge} ${getStatusClass(pedido.status)}`}>
            {pedido.status}
          </span>
        </div>

        <div className={styles.content}>
          <section className={styles.section}>
            <h3 className={styles.sectionTitle}>Informações do Cliente</h3>
            <div className={styles.infoGrid}>
              <div className={styles.infoItem}>
                <span className={styles.infoLabel}>Nome:</span>
                <span className={styles.infoValue}>{getNomeCliente(pedido.id_cliente)}</span>
              </div>
              <div className={styles.infoItem}>
                <span className={styles.infoLabel}>Email:</span>
                <span className={styles.infoValue}>{getEmailCliente(pedido.id_cliente)}</span>
              </div>
              <div className={styles.infoItem}>
                <span className={styles.infoLabel}>Telefone:</span>
                <span className={styles.infoValue}>{getTelefoneCliente(pedido.id_cliente)}</span>
              </div>
            </div>
          </section>

          <section className={styles.section}>
            <h3 className={styles.sectionTitle}>Informações do Pedido</h3>
            <div className={styles.infoGrid}>
              <div className={styles.infoItem}>
                <span className={styles.infoLabel}>Data:</span>
                <span className={styles.infoValue}>
                  {new Date(pedido.data_pedido).toLocaleString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </span>
              </div>
              {pedido.mesa && (
                <div className={styles.infoItem}>
                  <span className={styles.infoLabel}>Mesa:</span>
                  <span className={styles.infoValue}>{pedido.mesa}</span>
                </div>
              )}
              {pedido.observacao && (
                <div className={styles.infoItem}>
                  <span className={styles.infoLabel}>Observação:</span>
                  <span className={styles.infoValue}>{pedido.observacao}</span>
                </div>
              )}
            </div>
          </section>

          <section className={styles.section}>
            <h3 className={styles.sectionTitle}>Itens do Pedido</h3>
            {loading ? (
              <div className={styles.loading}>Carregando itens...</div>
            ) : itensPedido.length > 0 ? (
              <div className={styles.itensContainer}>
                {itensPedido.map((item, index) => (
                  <div key={index} className={styles.itemCard}>
                    <div className={styles.itemInfo}>
                      <span className={styles.itemNome}>{item.nome_item_externo || `Produto #${item.id_produto}`}</span>
                      <span className={styles.itemQuantidade}>Qtd: {item.quantidade}</span>
                    </div>
                    <span className={styles.itemTotal}>
                      R$ {Number(item.total_item || 0).toFixed(2)}
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              <p className={styles.emptyMessage}>Nenhum item encontrado</p>
            )}
          </section>

          <div className={styles.totalSection}>
            <div className={styles.totalRow}>
              <span className={styles.totalLabel}>Total do Pedido:</span>
              <span className={styles.totalValue}>R$ {Number(pedido.total || 0).toFixed(2)}</span>
            </div>
          </div>

          <NotaFiscalPedido idPedido={pedido.id_pedido} />
        </div>


      </div>
    </div>
  );
}

export default PopUpDetalhesPedido;